
import { defineComponent, ref } from 'vue'
import type { MetaInfo } from 'vue-meta'
import { useSEOMetaComposer } from '~/composables/seo.composable'
import AppImage from '~/components/AppImage/AppImage.vue'
import IconGift from '~/components/promos/black-promo/icons/IconGift.vue'
import IconBooks from '~/assets/icons/icon-books.svg?inline'
import IconLeaf from '~/assets/icons/icon-leaf.svg?inline'
import IconTree from '~/assets/icons/icon-tree.svg?inline'
import IconUsersFour from '~/assets/icons/icon-users-four.svg?inline'
import { AlButton } from '~/components/ui'
import CharitySlider from '~/components/CharitySlider/CharitySlider.vue'
import CharityMap from '~/components/CharityMap/CharityMap.vue'
import { getExternalCompareMobileHref } from '~/utils/external-links.utils'

export default defineComponent({
  name: 'CharityPage',
  components: {
    CharityMap,
    CharitySlider,
    AlButton,
    IconGift,
    AppImage,
    IconBooks,
    IconTree,
    IconLeaf,
    IconUsersFour,

  },
  setup () {
    const slides = ref([
      require('~/assets/images/charity/slides/slide-1.jpg'),
      require('~/assets/images/charity/slides/slide-2.jpg'),
      require('~/assets/images/charity/slides/slide-3.jpg'),
      require('~/assets/images/charity/slides/slide-4.jpg'),
      require('~/assets/images/charity/slides/slide-5.jpg'),
      require('~/assets/images/charity/slides/slide-6.jpg'),
      require('~/assets/images/charity/slides/slide-7.jpg'),
      require('~/assets/images/charity/slides/slide-8.jpg'),
      require('~/assets/images/charity/slides/slide-9.jpg'),
    ])
    return {
      slides,
    }
  },
  head (): MetaInfo {
    return useSEOMetaComposer(
      this,
      {
        title: this.$t('head.meta.index.title') as string,
        description: this.$t('head.meta.index.description') as string,
        route: { name: 'charity' },
      },
    )
  },
  computed: {
    externalCompareMobileHref () {
      return getExternalCompareMobileHref(this.$config.BASE_URL, this.localePath)
    },
  },
})
